import { useMemo } from 'react';

export const useIsProxySession = (currentUserId: string) => {
  const isProxySession = useMemo(() => {
    if (typeof window === 'undefined') {
      return false;
    }
    const proxySession = window.localStorage.getItem(`proxy#${currentUserId}`);
    return proxySession === 'true';
  }, [currentUserId]);
  return isProxySession;
};
